import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { string, number, bool, func } from 'prop-types';
import { Ellipsis, Item, IconButton, Left, Right } from './pagintation-item.styles';
export default function PaginationItem(props) {
  const {
    onClick,
    type,
    page,
    disabled,
    href
  } = props;
  const icon = ['previous', 'next'].includes(type);
  if (type === 'ellipsis') return /*#__PURE__*/React.createElement(Ellipsis, null, "...");
  return type === 'page' ? /*#__PURE__*/React.createElement(Item, _extends({
    href: href,
    role: "button",
    title: `página ${page}`,
    onClick: !props.selected && onClick
  }, props), page) : /*#__PURE__*/React.createElement(IconButton, _extends({
    onClick: onClick
  }, props), icon && (type === 'previous' ? /*#__PURE__*/React.createElement(Left, {
    disabled: disabled
  }) : /*#__PURE__*/React.createElement(Right, {
    disabled: disabled
  })));
}
PaginationItem.defaultProps = {
  disabled: false,
  href: null,
  onClick: () => {},
  page: null,
  selected: false
};
process.env.NODE_ENV !== "production" ? PaginationItem.propTypes = {
  disabled: bool,
  href: string,
  onClick: func,
  page: number,
  selected: bool,
  type: string.isRequired
} : void 0;